import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { CountUp } from '@/components/generals/count-up'
import { Container } from '@/components/generals/container'
import { SilkDrift } from '@/components/dots/silk-drift'
import { SectionLabel } from '@/components/landing/section-label'
import { STATS } from '@/constants/content'

export const StudioSection: FC = (): ReactNode => {
    return (
        <section id='studio' className='relative isolate bg-white'>
            <SilkDrift />

            <Container className='py-24 md:py-36'>
                <div className='grid gap-10 lg:grid-cols-12'>
                    <div className='lg:col-span-3'>
                        <SectionLabel index='01'>The studio</SectionLabel>
                    </div>

                    <Reveal className='lg:col-span-9'>
                        <p className='text-[clamp(1.75rem,3.4vw,3.25rem)] font-medium leading-[1.1] tracking-[-0.035em] text-ink'>
                            We are forty engineers, designers and data specialists building calm, dependable software for ambitious companies.
                            {' '}
                            <span className='text-ink/35'>
                                Small senior teams, weekly releases, and we stay long after launch.
                            </span>
                        </p>
                    </Reveal>
                </div>

                <ul className='mt-20 grid grid-cols-1 border-t border-line sm:grid-cols-2 md:mt-28 lg:grid-cols-4'>
                    {STATS.map((stat, index) => (
                        <li
                            key={stat.label}
                            className='border-b border-line py-8 sm:odd:pr-8 sm:even:border-l sm:even:pl-8 lg:border-b-0 lg:border-l lg:px-8 lg:first:border-l-0 lg:first:pl-0'
                        >
                            <Reveal delay={index * 90}>
                                <p className='font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground'>
                                    {stat.label}
                                </p>

                                <p className='mt-8 text-6xl font-medium tracking-[-0.05em] text-ink md:text-7xl'>
                                    <CountUp value={stat.value} suffix={stat.suffix} />
                                </p>

                                <p className='mt-4 max-w-[16rem] text-sm leading-relaxed text-muted-foreground'>
                                    {stat.note}
                                </p>
                            </Reveal>
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    )
}
